/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const EmailIcon = ({ width = 24, height = 24, hidden = false, title = 'Email' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M18 20.188 36 6.665v-1.5A1.147 1.147 0 0 0 34.875 4H1.125A1.147 1.147 0 0 0 0 5.167v1.469ZM24.779 17.963 36 26.367V9.541l-11.221 8.422z"
    />
    <path
      d="m22.866 19.4-3.576 2.694a2.172 2.172 0 0 1-2.58 0l-3.628-2.719L0 29.068v1.766A1.146 1.146 0 0 0 1.125 32h33.75A1.146 1.146 0 0 0 36 30.834v-1.59ZM11.165 17.938 0 9.512v16.683l11.165-8.257z"
    />
  </svg>`;
};
